import DNAStatsCard from "./DNAStatsCard";
export default DNAStatsCard;
